import { redirect } from "react-router-dom";

export default function ErrorPage() {
  return redirect("/services");
}
